module.exports = "<div class=\"form-group\" [formGroup]=\"form\">\n  <label [attr.for]=\"input.key\" class=\"block\" *ngIf=\"input.label!=''\">{{ input.label }}</label>\n  <img [src]=\"imgRoute\" alt=\"Imagen\" class=\"img-responsive wd-xl m-auto\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ing-dynamic-form/dynamic-form/input-img-preview/input-img-preview.component.html
// module id = 1310
// module chunks = 4